import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type NotificationLevel = "info" | "success" | "warning" | "error";

export interface AppNotification {
    id: string;          // unique (uuid / messageId+session...)
    title: string;       // ví dụ: "Tin nhắn mới từ ABC"
    message: string;     // nội dung ngắn gọn
    level: NotificationLevel;
    createdAt: number;   // Date.now()
    // dữ liệu phụ để khi click mở đúng chat
    sessionId?: string;
    chatId?: number;
    messageId?: number;
}

interface NotificationsState {
    items: AppNotification[];
}

const initialState: NotificationsState = {
    items: [],
};

export const pushNotificationSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        pushNotify: (state, action: PayloadAction<AppNotification>) => {
            console.log("🔔 New notification:", action.payload);
            // giữ tối đa 20 cái cho nhẹ
            state.items.unshift(action.payload);
            if (state.items.length > 20) {
                state.items.pop();
            }

        },
        removeNotification: (state, action: PayloadAction<string>) => {
            state.items = state.items.filter(n => n.id !== action.payload);
        },
        clearNotifications: (state) => {
            state.items = [];
        },
    },
});

export const {
    pushNotify,
    removeNotification,
    clearNotifications,
} = pushNotificationSlice.actions;

export default pushNotificationSlice.reducer;